import { withTranslation } from "react-i18next";
import Note from './Note';

export default withTranslation()(Note);